// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, useNavigate } from "react-router-dom";
import App from "./App";
import { App as CapApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style as StatusBarStyle } from "@capacitor/status-bar";

if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
  StatusBar.setStyle({ style: StatusBarStyle.Light }).catch(() => {});
}
// ✅ Handle deep links (like myapp://reset?token=abc)
function AppWithDeepLink() {
  const navigate = useNavigate();

  React.useEffect(() => {
    CapApp.addListener("appUrlOpen", ({ url }) => {
      try {
        const parsed = new URL(url);
        // Example: https://sports-app/reset?token=abc
        const path = parsed.pathname + parsed.search;
        navigate(path);
      } catch (err) {
        console.warn("Deep link parse failed:", err);
      }
    });
  }, [navigate]);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AppWithDeepLink />
  </BrowserRouter>
);
